import type { FC, SVGProps } from "react"

const SvgContractSigning: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 17.082 17.082"
    fill="currentColor"
    {...props}
  >
    <g>
      <path
        data-name="Path 123"
        d="M8.529 10.587c.546.546 3.466-2.108 4.6-3.19l-1.406-1.406c-1.088 1.129-3.746 4.041-3.194 4.596Z"
      />
      <path
        data-name="Path 124"
        d="M15.278 2.838a26.027 26.027 0 0 0-2.85 2.447l1.4 1.4a26.027 26.027 0 0 0 2.447-2.85c.669-.936.932-1.555.742-1.745-.282-.283-1.409.512-1.739.748Z"
      />
      <path data-name="Path 125" d="M3.036 3.036V.293L.293 3.036Z" />
      <path
        data-name="Path 126"
        d="m8.262 11.562-.94.94-.708-.703.908-.908c-.293-.658-.042-2.081 3.838-5.961a34.958 34.958 0 0 1 1.717-1.608V-.001h-9.04v4.038H0v13.044h13.078V8.826c-1.184 1.095-3.453 3.206-4.816 2.736ZM2.035 5.038h5.038v1H2.035Zm0 2h3v1h-3Zm0 2h3v1h-3Zm4.081 5.71a1.9 1.9 0 0 0-.493-.68 2.107 2.107 0 0 0-.09.2c-.213.493-.526.863-1.075.774-.6-.1-.694-.753-.767-1.279a2.123 2.123 0 0 0-.177-.731 2.517 2.517 0 0 0-.477 1.548l-1-.064c.026-.412.221-2.47 1.5-2.47.927 0 1.063.989 1.145 1.58v.022a1 1 0 0 1 .887-.6c.835 0 1.361 1.08 1.458 1.3Z"
      />
    </g>
  </svg>
)

export default SvgContractSigning
